// This function checks if a key exists in an object at a given path.
// For example, it's used by the /book section, which has dynamic paths we want to render
// specific text for, if it exists.

const checkKeyExistsInObject = (obj: unknown, path: string): boolean => {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  return path.split('.').every(key => {
    if (typeof obj === 'object' && obj !== null && key in obj) {
      obj = (obj as Record<string, unknown>)[key];

      return true;
    }

    return false;
  });
};

export default checkKeyExistsInObject;
